<template>
  <v-card v-if="major">
    <v-img :src="url" height="200px"></v-img>

    <v-card-title class="text-truncate">
      {{ major.title }}
    </v-card-title>

    <v-card-subtitle class="text-truncate">
      {{ major.descriptions }}
    </v-card-subtitle>
    <v-card-actions>
      <v-btn text :to="'/major/' + major.id">
        <span>Cấu Hình</span>
        <v-icon color="#FFB300">arrow_forward</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
  <v-skeleton-loader type="card" v-else></v-skeleton-loader>
</template>

<script>
import { get } from 'lodash'
export default {
  props: {
    major: Object,
  },
  computed: {
    url() {
      if (!this.major.avatar || !this.major.avatar.url)
        return '/cover-default.jpg'
      const imgUrl = get(this.major, 'avatar.url')
      if (!/^http/.test(imgUrl)) {
        return `${process.env.VUE_APP_API_ENDPOINT}${imgUrl}`
      } else {
        return imgUrl
      }
    },
  },
}
</script>

<style scoped>
</style>
